<template>
  <div>
    <v-simple-table fixed-header>
      <template v-if="loading">
        <Load :loading-msg="loadingMsg" />
      </template>
      <div
        v-else
        class="mr-5 ml-5"
        style="cursor: pointer;"
      >
        <v-data-table
          :headers="headers"
          :items="contracts"
          :items-per-page="5"
          loading-text="carregando lista"
          no-data-text="Nenhum contrato encontrado"
          item-key="id"
          @click:row="getContract($event)"
        >
          <template
            #item.id="{ item }"
          >
            <template v-if="item.is_current">
              <v-chip
                color="green"
                dark
              >
                {{ item.id }} - Atual
              </v-chip>
            </template>
            <span v-else>
              {{ item.id }}
            </span>
          </template>
          <template
            #item.starts_at="{ item }"
          >
            {{ returnData(item.starts_at) }}
          </template>
          <template
            #item.expires_at="{ item }"
          >
            {{ returnData(item.expires_at) }}
          </template>
          <template
            #item.renews_at="{ item }"
          >
            {{ returnData(item.renews_at) }}
          </template>
        </v-data-table>
      </div>
    </v-simple-table>
    <Contract
      :contract-id="contractSelected"
    />
  </div>
</template>

<script>
import Contract from '@/components/schools/contracts/Contract.vue'
import Load from '@/components/Loading.vue'
import dayjs from '@/dayjs'

export default {
  components: {
    Load,
    Contract
  },
  props: {
    institutionId: { type: Number, required: true }
  },
  data: () => ({
    loading: true,
    loadingMsg: 'carregando',
    contracts: [],
    contractSelected: null,
    headers: [
      {
        text: 'Id',
        align: 'center',
        value: 'id'
      },
      {
        text: 'Inicio',
        align: 'center',
        value: 'starts_at'
      },
      {
        text: 'Final',
        align: 'center',
        value: 'expires_at'
      },
      {
        text: 'Renovação',
        align: 'center',
        value: 'renews_at'
      }
    ]
  }),
  async created () {
    if (this.institutionId > 0) {
      await this.getContracts()
    }
  },
  methods: {
    async getContracts () {
      try {
        this.contracts = await this.$api.getContracts(this.institutionId)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    returnData (data) {
      return dayjs(data).utc().format('DD-MM-YYYY')
    },

    getContract (contract) {
      this.contractSelected = contract.id
    },
    // async getContract (contract) {
    //   try {
    //     this.contractSelected = await this.$api.getContract(contract.id)
    //     console.log(this.contractSelected)
    //   } catch (e) {
    //     this.$store.dispatch('setSnackbar', {
    //       text: 'Erro ao carregar contrato',
    //       color: 'red'
    //     })
    //   }
    // },

    dayjs
  }
}
</script>
